export default __webpack_public_path__ + "static/media/succion de fosas1.6b62bc88.jpg";